import React, { memo } from 'react';
import ChatCard from './components/ChatCard';

const Chat = () => {
  return <ChatCard />;
};

export default memo(Chat);
